import React, { useState } from "react"
import { Button, P2 } from "components"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import { newArchAxiosInstance } from "utils/request"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { onQueryError } from "utils/utils"
import EmployeeKeyResult from "./EmployeeKeyResult"
import { IEmpObjRes } from "../../interface/individual"
import {
  KR,
  OBJ,
} from "pages/dashboard/performance/components/objectives/ObjCardComponents"
import { CreateEditKR } from "pages/dashboard/performance/components/objectives/CreateEditKR"
import { useSearchParams } from "react-router-dom"
interface props {
  data: IEmpObjRes | undefined
  setOpenCreatObj: (value: boolean) => void
  title: string
  emptyStateText?: string
  activeObj: number | null
  setActiveObj: React.Dispatch<React.SetStateAction<number | null>>
  selectedCycle: number | null
  onDeleteKRSuccess: () => void
  delEndpoint: string
  viewEndpoint: string
  pageType: "admin" | "manager" | "employee"
}

interface ModalState {
  type: "delete" | ""
  data: {
    title: string
    keyResultId: number
    cycleDurationId: number
  } | null
}

const IndividualFlow = ({
  data,
  setOpenCreatObj,
  title = "individual",
  emptyStateText,
  activeObj,
  setActiveObj,
  selectedCycle,
  onDeleteKRSuccess,
  delEndpoint,
  viewEndpoint,
  pageType,
}: props) => {
  const [showAddKR, setShowAddKR] = useState(false)
  const [showAddIndKR, setShowAddIndKR] = useState(false)
  const [editOKR, setEditOKR] = useState(null)
  const [searchParams] = useSearchParams()
  const employeeId = searchParams.get("x")
  const queryClient = useQueryClient()

  const [modal, setModal] = useState<ModalState>({
    type: "",
    data: null,
  })

  const { isLoading: isDeletingOKR, mutate: deleteOKR } = useMutation({
    mutationFn: async (id: string) => {
      const res = await newArchAxiosInstance.delete(`${delEndpoint}/${id}`)
      return res.data
    },
    onSuccess: (data) => {
      if (data.success) {
        setModal({
          type: "",
          data: null,
        })
        queryClient.invalidateQueries({
          queryKey: [
            `/api/v2/admin/okr/employeekeyresults/${activeObj}/${employeeId}/${modal?.data?.cycleDurationId}`,
          ],
        })
        onDeleteKRSuccess()
      }
    },
    onError: onQueryError,
  })

  return (
    <div className="min-h-[429px]">
      {data?.data && data?.data?.length > 0 ? (
        <div className=" flex flex-col gap-4">
          {data?.data?.map((item, index) => (
            <div
              key={index}
              className=" w-full bg-white p-5 shadow-sm rounded-5px"
            >
              <div className="mb-3 flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <OBJ.CollapseExpandButton
                    expanded={item?.departmentObjectiveId === activeObj}
                    onClick={() =>
                      setActiveObj((prev) =>
                        prev === item?.departmentObjectiveId
                          ? null
                          : item?.departmentObjectiveId
                      )
                    }
                  />
                  <OBJ.ObjTypeImg objType="Individual" />
                  <OBJ.ObjTypeTag
                    title={"Individual"}
                    objType="Individual"
                  />
                </div>
                {/* <Dropdown
                  menu={{
                    items: actionItems(item),
                  }}
                >
                  <button>
                    <EllipsisHorizontalIcon className="w-6 h-6 text-primary500" />
                  </button>
                </Dropdown> */}
              </div>
              <div className=" mb-4  flex justify-between items-start ">
                <div>
                  <OBJ.ObjTitle title={item?.departmentObjectiveName} />
                  <OBJ.ObjCreatedDate date={item?.createdDate} />
                </div>

                <OBJ.ObjKRCountTag krCount={item?.keyResultCount} />
              </div>

              <OBJ.ObjProgress progress={item?.currentProgress} />

              {item?.departmentObjectiveId === activeObj && (
                <KR.KRsWrapper>
                  {activeObj == item?.departmentObjectiveId && (
                    <EmployeeKeyResult
                      onDelete={(id) => {
                        setModal({
                          type: "delete",
                          data: {
                            title: item?.departmentObjectiveName,
                            keyResultId: id,
                            cycleDurationId: item?.cycleDurationId,
                          },
                        })
                      }}
                      item={item}
                      pageType={pageType}
                      viewEndpoint={`${viewEndpoint}/${item?.departmentObjectiveId}`}
                    />
                  )}

                  <CreateEditKR
                    onClose={() => {
                      setShowAddKR(false)
                    }}
                    open={showAddKR}
                    // open={true}
                    role={pageType}
                    deptObjId={item?.departmentObjectiveId}
                    deptId={item?.departmentId}
                  />

                  {/* REMOVE LATER  */}
                  {/* ADD NEW OKR */}
                  {/* {showAddKR && activeObj && (
                    <CreateKeyResult
                      handleClose={() => setShowAddKR(!showAddKR)}
                      activeObj={activeObj}
                    />
                  )} */}
                  {/* {showAddIndKR && ( */}
                  {/* <CreateIndKR
                    open={showAddIndKR}
                    handleClose={() => setShowAddIndKR(!showAddIndKR)}
                    selectedCycle={selectedCycle}
                  /> */}

                  {/* )} */}

                  <KR.KRAddButton
                    onClick={() => {
                      setShowAddKR(!showAddKR)
                    }}
                  />
                </KR.KRsWrapper>
              )}
            </div>
          ))}
        </div>
      ) : (
        <OBJ.ObjEmptyState
          showBtn={pageType !== "employee"}
          btnText="Create Employee Key Result"
          onCreate={() => setOpenCreatObj(true)}
          text={emptyStateText ?? " Set your first objective to get started."}
        />
      )}
      <CustomModal
        open={modal.type === "delete"}
        onCancel={() => {
          setModal({ type: "", data: null })
        }}
        title={`Delete ${modal?.data?.title}`}
        footer={
          <div className="flex justify-end gap-4">
            <Button
              color="neutral"
              onClick={() => {
                setModal({ type: "", data: null })
              }}
              // disabled={isDeletingGroup}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => {
                deleteOKR(modal?.data?.keyResultId?.toString() as string)
              }}
              disabled={isDeletingOKR}
              submitting={isDeletingOKR}
            >
              Delete
            </Button>
          </div>
        }
      >
        <P2 className=" font-normal  font-avenir text-neutral500">
          This key result will be permanently removed from the objective. You
          won’t be able to undo this action.
        </P2>
      </CustomModal>
    </div>
  )
}

export default IndividualFlow
